import { createContext, useContext } from 'react';
import { IProps } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';
import { IReportBuilderConfig } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';

interface IReportBuilderContext {
  cfg: IReportBuilderConfig;
  props: IProps;
}

export const ReportBuilderContext = createContext({} as IReportBuilderContext);
export const useReportBuilderStore = (): IReportBuilderContext => useContext(ReportBuilderContext);
